import formBaseMixin from '@/components/form/form-base-mixin'
import { STATUS_NOT_ACTIVE } from '@/config/config'
import { wasteGeneratorsOffline } from '@/api/api-offline-endpoints'
import {
  NORMATIVE_TYPE_LEGAL,
  NORMATIVE_TYPE_MKD,
  NORMATIVE_TYPE_INDIVIDUAL,
} from '@/config/config'
import url from '@/utils/url'
import { BILL_FORM, IS_OWNER } from '../types/types'

export default {
  mixins: [formBaseMixin],
  props: {
    parentItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      fields: {
        number: 'Будет сгенерирован автоматически после сохранения',
        name: '',
        inn: '',
        kpp: '',
        address: '',
        part: '',
        flat: '',
        status: '',
        start: '',
        end: '',
        square: '',
        status_id: '',
        standard: [],
        individuals: [],
        fias_id: '',
        sba_id: '',
        hcs_id: '',
        closing_reason: '',
        note: '',
        opened_at: '',
        room: '',
        communal_apartment: false,

        district_id: '',
        city_id: '',
        locality_id: '',
        area_id: '',
        street_id: '',
        house_id: '',
      },
    }
  },
  computed: {
    ownerIndividual() {
      const individuals = this.bankBooksIndividuals.data
      let owner = {}
      individuals.forEach((individual) => {
        if (individual.is_owner === IS_OWNER) {
          owner = individual
          if (individual.name) {
            owner.fullName = `${individual.surname} ${individual.name} ${individual.patronymic}`
          }
        }
      })
      return owner
    },
    formTitle() {
      if (this.fields && this.fields.id) {
        return (
          this.fields.name ||
          `${this.parentItem.fact_address || ''}, №ЛС ${
            this.fields.number || ''
          }`
        )
      }
      return this.$translate('Добавление лицевого счета')
    },
    identityCardTypesById() {
      const cardsById = {}
      if (this.identityCardTypes) {
        this.identityCardTypes.forEach(({ id, name }) => {
          cardsById[id] = name
        })
      }

      return cardsById
    },
    identityCardTypes() {
      return this.collection.identity_card_type
    },
    bankBookNormativeValidateAlias() {
      return 'standard'
    },
    bankBookIndividualsValidateAlias() {
      return 'individual'
    },
    disabledInEditMode() {
      return !!(this.$route.params.objectId && this.$route.params.id)
    },
    NORMATIVE_TYPE_INDIVIDUAL() {
      return NORMATIVE_TYPE_INDIVIDUAL
    },
    NORMATIVE_TYPE_MKD() {
      return NORMATIVE_TYPE_MKD
    },
    NORMATIVE_TYPE_LEGAL() {
      return NORMATIVE_TYPE_LEGAL
    },
    itemId() {
      return this.$route.params.objectId || this.$route.params.id || null
    },
    notActive() {
      return STATUS_NOT_ACTIVE
    },
    collection() {
      return (
        this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      )
    },
    statuses() {
      return this.collection.billing_account_status || []
    },
    bankBooksNormatives() {
      return (
        this.$store.getters.readUrlEndpoint(
          this.bankBooksNormativesDataUrl()
        ) || { data: [] }
      )
    },
    bankBooksIndividuals() {
      return (
        this.$store.getters.readUrlEndpoint(
          this.bankBooksIndividualsDataUrl()
        ) || { data: [] }
      )
    },
    item() {
      if (this.isOffline()) {
        // show draft item from store
        let item = null
        const items = this.$store.getters.readUrlEndpoint(
          this.getOfflineBankBooksDataUrl()
        )
        if (items && items.data) {
          items.data.forEach((v) => {
            if (v._storeUUID === this.$route.params.objectId) {
              item = v
            }
          })
        }
        return item
      }
      return this.$store.getters.readUrlEndpoint(
        this.getItemEndpoint(this.$route)
      )
    },
    partValidationRules() {
      return {
        specialValidate: this.validatePart,
      }
    },
  },
  beforeDestroy() {
    // reset bankBooksNormatives
    this.$store.commit('setEndpointData', {
      endpoint: this.bankBooksNormativesDataUrl(),
      data: {
        data: [],
      },
    })
    // reset bankBooksIndividuals
    this.$store.commit('setEndpointData', {
      endpoint: this.bankBooksIndividualsDataUrl(),
      data: {
        data: [],
      },
    })
  },
  methods: {
    emitterFormName() {
      return BILL_FORM
    },
    validatePart(msg) {
      if (
        isNaN(this.fields.part) ||
        this.fields.part <= 0 ||
        this.fields.part > 100
      ) {
        msg = 'Укажите значение в процентах от +0 до 100'
      }
      return msg
    },
    onSuccess() {
      const isOffline = this.isOffline()
      this.onSaveForm()
      setTimeout(() => {
        let route = url.getRedirectRoute(this.$route)
        this.$router.push(route, () => {
          if (isOffline) {
            this.showOnSuccess(
              'Запись будет сохранена после сохранения источника образования отхода'
            )
          } else {
            this.showOnSuccess('Запись сохранена')
          }
          this.unFreezeFrom()
        })
      }, 0)
    },
    onStatusChange() {
      this.fields.status = null
      if (this.fields.status_id) {
        let fIdx = this.statuses.findIndex((v) => v.id == this.fields.status_id)
        if (fIdx > -1) {
          this.fields.status = this.statuses[fIdx]
        }
      }
    },
    getOfflineBankBooksDataUrl() {
      return wasteGeneratorsOffline.bankBooks()
    },
    bankBooksNormativesDataUrl() {
      return wasteGeneratorsOffline.bankBooksNormatives()
    },
    bankBooksIndividualsDataUrl() {
      return wasteGeneratorsOffline.bankBooksIndivduals()
    },
    isOffline() {
      return !this.$route.params.id
    },
    saveForm() {
      if (this.isOffline()) {
        this.offlineSaveForm()
      } else {
        formBaseMixin.methods.saveForm.call(this)
      }
    },
    offlineSaveForm() {
      const action = this.fields._storeUUID ? 'updateModel' : 'createModel'
      this.$store
        .dispatch(action, {
          endpoint: this.getOfflineBankBooksDataUrl(),
          offline: true,
          data: this.prepareFieldsForSend(this.fields),
          action: 'prepend',
        })
        .then(() => {
          this.onSuccess()
        })
        .catch((e) => {
          this.showOnError(e)
        })
    },
    transformFieldsBeforeSend() {
      if (this.bankBooksNormatives.data.length > 0) {
        this.fields.standard = this.bankBooksNormatives.data.slice()
        if (this.isOffline()) {
          this.fields.normative = this.bankBooksNormatives.data.slice()
        }
      }
      if (this.bankBooksIndividuals.data.length > 0) {
        // Form
        this.fields.individual = this.bankBooksIndividuals.data.slice()
        if (this.isOffline()) {
          // DTO
          this.fields.individuals = this.bankBooksIndividuals.data.slice()
        }
      }
    },
    initFieldsAfterLoad() {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        this.update()
      }
    },
    update() {
      // copy data from item arr to store in offline endpoint
      const normative = this.item.normative || []
      // put data to store
      this.$store.commit('setEndpointData', {
        endpoint: this.bankBooksNormativesDataUrl(),
        data: {
          // drop deep link to objects
          data: JSON.parse(JSON.stringify(normative)),
        },
      })
      // and update table
      this.$refs.bankBooksNormatives &&
        this.$refs.bankBooksNormatives.fetchData()

      const individuals = this.item.individuals || []
      // put data to store
      this.$store.commit('setEndpointData', {
        endpoint: this.bankBooksIndividualsDataUrl(),
        data: {
          data: JSON.parse(JSON.stringify(individuals)),
        },
      })
      // and update table
      this.$refs.bankBooksIndividuals &&
        this.$refs.bankBooksIndividuals.fetchData()
    },
    getStoreAction() {
      return this.$route.params.objectId ? 'updateModel' : 'createModel'
    },
  },
  asyncData({ store, route, fromRoute, methods }) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getItemEndpoint(route, fromRoute),
        })
      )
    }

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true,
      })
    )

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  },
}
